import { PossibleBigNumber } from '@ui/types/utility';

export const getEstPnl = ({
  collateralUsd,
  targetPercentage,
  spreadPercentage,
  isLong,
}: {
  collateralUsd: PossibleBigNumber;
  targetPercentage: number;
  spreadPercentage: number;
  isLong: boolean;
}) => {
  return (
    collateralUsd
      /**
       *
       * need to involve spread percentage here, involve  details:
       *
       * (target price - entry price ) * qty = estPnl
       *
       * collateralUsd * targetPercentage  = estPnl
       *
       * collateralUsd * leverage / entry price = qty ->
       *
       * collateralUsd = qty * entry price / leverage
       *
       * since entryPrice is being impacted by spread percentage, we need to adjust the formula
       *
       */
      ?.multipliedBy(isLong ? 1 + spreadPercentage : 1 - spreadPercentage)
      .multipliedBy(targetPercentage)
      .toNumber()
  );
};
